import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"upload\"><path d=\"M6.21 7.21L9 4.41V14c0 .55.45 1 1 1s1-.45 1-1V4.41l2.79 2.79c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41L10 .59l-5.21 5.2a.996.996 0 000 1.41c.39.39 1.03.4 1.42.01zM18 14v3.1a1.9 1.9 0 01-1.9 1.9H3.9A1.9 1.9 0 012 17.1V14H0v3.1C0 19.25 1.75 21 3.9 21h12.2c2.15 0 3.9-1.75 3.9-3.9V14h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol